import {UTC_SUCCESS, UTC_FAILURE} from '../get-templates/constants'

export async function updateAuditsCount(id, dispatch) {
  try {
    dispatch({type: UTC_SUCCESS, payload: id})
  } catch (e) {
    console.log(`Update Template Audits Count Failed`)
    dispatch({type: UTC_FAILURE, payload: e})
  }
}
